import { requestGet, requestPost, requestPostFile } from "../config/Api";

// Sube 1..N archivos .json del outbox del exportador local.
// data: FormData con files[] (o file)
export const uploadJudicialImports = (data) => {
  return requestPostFile("judicial/import", data);
};

export const getJudicialImports = (params = {}) => {
  return requestGet("judicial/import", params);
};

export const getJudicialImport = (id) => {
  return requestGet(`judicial/import/${id}`);
};

export const retryJudicialImport = (id) => {
  return requestPost(`judicial/import/${id}/retry`);
};
